const SmallChevronIcon = (props) => (
  <svg width="6" height="4" viewBox="0 0 6 4" {...props} className={`fill-current ${props?.className ? props?.className : ''}`} xmlns="http://www.w3.org/2000/svg">
    <path d="M3.00005 3.99997L0.171387 1.1713L1.11472 0.228638L3.00005 2.11464L4.88539 0.228638L5.82872 1.1713L3.00005 3.99997Z" />
  </svg>
);

export default SmallChevronIcon;
